import type { AvatarProps } from 'stream-chat-react';
import { Avatar } from 'stream-chat-react';

const DEFAULT_GRAVATAR = 'https://www.gravatar.com/avatar?d=mp';

export const StreamChatAvatar = ({ image, ...props }: AvatarProps) => <Avatar image={image === DEFAULT_GRAVATAR ? undefined : image} {...props} />;
